import {StringUtils} from "./string.utils";

const INTERNATIONAL_PREFIX_STANDARD = '+';
const INTERNATIONAL_PREFIX_SECONDARY = '00';
const NATIONAL_PREFIX = '0';

export class PhoneUtils {
    public static phoneNumberFromCountry(phoneNumber:string, dialingCodeCountry:string): boolean {
        if(! this.internationalPhoneNumber(phoneNumber)) {
            return false;
        }
        if(phoneNumber.startsWith(INTERNATIONAL_PREFIX_SECONDARY)) {
            return phoneNumber.replace(INTERNATIONAL_PREFIX_SECONDARY, '')
                .startsWith(dialingCodeCountry);
        }
        if(phoneNumber.startsWith(INTERNATIONAL_PREFIX_STANDARD)) {
            return phoneNumber.replace(INTERNATIONAL_PREFIX_STANDARD, '')
                .startsWith(dialingCodeCountry);
        }
    }

    public static convertToInternationalPhoneNumber(phoneNumber:string, dialingCode?:string):string {
        if (! phoneNumber) {
            return undefined;
        }
        phoneNumber = StringUtils.removeWhitespaces(phoneNumber);
        if(this.internationalPhoneNumber(phoneNumber)) {
            return this.setStandardInternationalPhoneNumber(phoneNumber);
        }
        if(phoneNumber.charAt(0) === NATIONAL_PREFIX) {
            phoneNumber = phoneNumber.slice(1);
        }
        if (phoneNumber?.length == 0) {
           return undefined;
        }
        return dialingCode ? dialingCode + phoneNumber : phoneNumber;
    }

    private static internationalPhoneNumber(phoneNumber:string):boolean {
        return phoneNumber && (phoneNumber.startsWith(INTERNATIONAL_PREFIX_SECONDARY)
            || phoneNumber.startsWith(INTERNATIONAL_PREFIX_STANDARD));
    }

    private static setStandardInternationalPhoneNumber(phoneNumber:string):string {
        if(phoneNumber && phoneNumber.startsWith(INTERNATIONAL_PREFIX_SECONDARY)) {
            return phoneNumber.replace(INTERNATIONAL_PREFIX_SECONDARY, INTERNATIONAL_PREFIX_STANDARD);
        }
        return phoneNumber;
    }
}